import TH_Initer from "_tradeholding/js/Classes/Initer";

let Init = new TH_Initer();

export default Init;